<template>
    <div :class="isAfert ? 'entity-compare-after' : ''">
        <div>
            <div class="tab-heading">
                <h2>{{ t('patients::tabs.items.details') }}</h2>
            </div>
            <div class="tab-sub-heading">
                <h3>{{ t('patients::form.title.general_information') }}</h3>
            </div>
            <div class="notification-field surname">
                <label class="label"
                    >{{ t('patients::form.label.surname') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.surname }}</div>
            </div>
            <div class="notification-field forename">
                <label class="label"
                    >{{ t('patients::form.label.forename') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.forename }}</div>
            </div>
            <div class="notification-field birth_date">
                <label class="label"
                    >{{ t('patients::form.label.birth_date') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ dateFormat(store.birth_date) }}</div>
            </div>
            <div class="notification-field nhs_id">
                <label class="label">{{ t('patients::form.label.nhs_id') }}</label>
                <div class="value">{{ store.nhs_id }}</div>
            </div>
            <div class="notification-field gender">
                <label class="label">{{ t('patients::form.label.gender') }} {{ $root.defaultMandatoryAsteriks }}</label>
                <div class="value">{{ getSelectItem(genderSelectItems, store.gender) }}</div>
            </div>
            <div class="notification-field race">
                <label class="label">{{ t('patients::form.label.race') }} {{ $root.defaultMandatoryAsteriks }}</label>
                <div class="value">{{ getSelectItem(raceSelectItems, store.race) }}</div>
            </div>
            <div class="tab-sub-heading">
                <h3>{{ t('patients::form.title.pharmacy_n_consultant') }}</h3>
            </div>
            <div class="notification-field pharmacy_site pharmacy_site_id">
                <label class="label"
                    >{{ t('patients::form.label.pharmacy_site') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ getSelectItem(pharmaciesOptions, store.pharmacy_site_id) }}</div>
            </div>
            <div class="notification-field consultant consultant_id">
                <label class="label"
                    >{{ t('patients::form.label.consultant') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ getSelectItem(consultantsOptions, store.consultant_id) }}</div>
            </div>
            <div class="notification-field consultant collection_centre">
                <label class="label">{{ t('patients::form.label.collection_centre') }}</label>
                <div class="value">{{ getSelectItem(collectionCentresOptions, store.collection_centre) }}</div>
            </div>
            <div class="tab-sub-heading">
                <h3>{{ t('patients::form.title.address') }}</h3>
            </div>
            <div class="notification-field address">
                <label class="label">{{ t('patients::form.label.address') }}</label>
                <div class="value">{{ store.address }}</div>
            </div>
            <div class="notification-field second_address">
                <label class="label">{{ t('patients::form.label.address_line') }}</label>
                <div class="value">{{ store.second_address }}</div>
            </div>
            <div class="notification-field post_code">
                <label class="label">{{ t('patients::form.label.post_code') }}</label>
                <div class="value">{{ store.post_code }}</div>
            </div>
            <div class="notification-field country">
                <label class="label">{{ t('patients::form.label.country') }}</label>
                <div class="value">{{ store.country }}</div>
            </div>
            <div class="notification-field region">
                <label class="label">{{ t('patients::form.label.county') }}</label>
                <div class="value">{{ store.region }}</div>
            </div>
            <div class="notification-field town">
                <label class="label">{{ t('patients::form.label.town') }}</label>
                <div class="value">{{ store.town }}</div>
            </div>
        </div>
        <div>
            <div class="tab-heading">
                <h2>{{ t('patients::tabs.items.health_info') }}</h2>
            </div>
            <div class="notification-field health_information-cnrd_date">
                <label class="label">{{ t('patients::form.label.cnrd_date') }} </label>
                <div class="value">{{ dateFormat(store.health_information.cnrd_date) }}</div>
            </div>
            <div class="notification-field health_information-up_to_including_date">
                <label class="label">{{ t('patients::form.label.including_date') }}</label>
                <div class="value">{{ dateFormat(store.health_information.up_to_including_date) }}</div>
            </div>
            <div class="notification-field health_information-normal_blood_sample_day">
                <label class="label">{{ t('patients::form.label.normal_blood_sample_day') }} </label>
                <div class="value">
                    {{ getSelectItem(daysOptions, store.health_information.normal_blood_sample_day) }}
                </div>
            </div>
            <div class="notification-field health_information-is_checked">
                <label class="label">{{ t('patients::form.label.checked_cnrd') }} </label>
                <div class="value">
                    {{ getStatus(store.health_information.is_checked) }}
                </div>
            </div>
            <div class="notification-field health_information-cnrd_entry_found">
                <label class="label">
                    {{ t('patients::form.label.cnrd_entry_found') }}
                </label>
                <div class="value">{{ store.health_information.cnrd_entry_found }}</div>
            </div>
            <div class="notification-field is_registered">
                <label class="label">{{ t('patients::form.label.is_registered') }} </label>
                <div class="value">
                    {{ getStatus(store.is_registered) }}
                </div>
            </div>
            <div class="notification-field status">
                <label class="label">{{ t('patients::form.label.patient_status') }} </label>
                <div class="value">
                    {{ getSelectItem(patientStatusOptions, store.status) }}
                </div>
            </div>
            <div class="notification-field health_information-is_with_ben">
                <label class="label">{{ t('patients::form.label.ben_diagnosed') }} </label>
                <div class="value">
                    {{ getStatus(store.health_information.is_with_ben) }}
                </div>
            </div>
        </div>
        <div>
            <div class="tab-heading">
                <h2>{{ t('patients::tabs.items.diagnosis') }}</h2>
            </div>
            <div class="notification-field diagnosis-diagnosis">
                <label class="label"
                    >{{ t('patients::form.label.diagnosis') }} {{ $root.defaultMandatoryAsteriks }}</label
                >
                <div class="value">{{ store.diagnosis.diagnosis }}</div>
            </div>
            <div class="notification-field diagnosis-previous_anti_psychotics">
                <label class="label">{{ t('patients::form.label.previous_anti_psychotics') }}</label>
                <div class="value">{{ store.diagnosis.previous_anti_psychotics }}</div>
            </div>
            <div class="notification-field diagnosis-ward_name">
                <label class="label">{{ t('patients::form.label.ward_name') }}</label>
                <div class="value">{{ store.diagnosis.ward_name }}</div>
            </div>

            <div class="notification-field diagnosis-is_prescribed_clozapine">
                <label class="label">{{ t('patients::form.label.prescribed_clozapine') }}</label>
                <div class="value">{{ getStatus(store.diagnosis.is_prescribed_clozapine) }}</div>
            </div>

            <div class="notification-field diagnosis-is_with_sch">
                <label class="label">{{ t('patients::form.label.has_sch') }}</label>
                <div class="value">{{ getStatus(store.diagnosis.is_with_sch) }}</div>
            </div>

            <div class="notification-field diagnosis-is_chemo_or_observation">
                <label class="label">{{ t('patients::form.label.special_observation') }}</label>
                <div class="value">{{ getStatus(store.diagnosis.is_chemo_or_observation) }}</div>
            </div>

            <div class="notification-field diagnosis-is_under_monitoring">
                <label class="label">{{ t('patients::form.label.special_monitoring') }}</label>
                <div class="value">{{ getStatus(store.diagnosis.is_under_monitoring) }}</div>
            </div>

            <div class="notification-field diagnosis-is_with_park">
                <label class="label">{{ t('patients::form.label.has_park') }}</label>
                <div class="value">{{ getStatus(store.diagnosis.is_with_park) }}</div>
            </div>

            <div class="notification-field diagnosis-is_with_bone_disease">
                <label class="label">{{ t('patients::form.label.bone_disease') }}</label>
                <div class="value">{{ getStatus(store.diagnosis.is_with_bone_disease) }}</div>
            </div>

            <div class="notification-field diagnosis-is_in_patient">
                <label class="label">{{ t('patients::form.label.treatment_place') }}</label>
                <div class="value">{{ getStatus(store.diagnosis.is_in_patient) }}</div>
            </div>

            <div class="notification-field diagnosis-suspension">
                <label class="label">{{ t('patients::form.label.denzapine_suspension') }}</label>
                <div class="value">{{ getStatus(store.diagnosis.suspension) }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'NotificationApprovalRequestForm',
    components: {},
    props: {
        store: {
            type: Object,
            required: true,
        },
        isAfert: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            genderSelectItems: [
                { text: 'Male', value: 'male' },
                { text: 'Female', value: 'female' },
                { text: 'Other', value: 'other' },
            ],
            raceSelectItems: [
                { text: 'Caucasian', value: 'caucasian' },
                { text: 'Asian', value: 'asian' },
                { text: 'Afro-Caribbean', value: 'afro-caribbean' },
                { text: 'Mixed', value: 'mixed' },
                { text: 'Other', value: 'other' },
            ],
            daysOptions: [
                { text: 'Monday', value: 'monday' },
                { text: 'Tuesday', value: 'tuesday' },
                { text: 'Wednesday', value: 'wednesday' },
                { text: 'Thursday', value: 'thursday' },
                { text: 'Friday', value: 'friday' },
                { text: 'Saturday', value: 'saturday' },
                { text: 'Sunday', value: 'sunday' },
            ],
        };
    },
    computed: {
        updatedProps() {
            return this.$store.state.notification_patient.updatedProps.map((x) => x.replace('.', '-'));
        },
        patientStatusOptions() {
            return this.$store.state.patients.patientStatusOptions;
        },
        pharmaciesOptions() {
            return this.$store.state.patients.pharmaciesOptions.map((x) => ({ value: x.id, text: x.name }));
        },
        consultantsOptions() {
            return this.$store.state.patients.consultantsOptions.map((x) => ({ value: x.id, text: x.name }));
        },
        collectionCentresOptions() {
            return this.$store.state.patients.collectionCentresOptions.map((x) => ({ value: x.id, text: x.name }));
        },
    },
    watch: {
        updatedProps() {
            this.removeActiveItems();
            this.setActiveItems();
        },
    },
    mounted() {
        this.setActiveItems();
    },
    created() {},
    methods: {
        getStatus(status) {
            return status ? 'True' : 'False';
        },
        dateFormat(date) {
            return date ? moment(date).format(this.$root.dateFormat) : null;
        },
        getSelectItem(items, value) {
            return items.find((x) => x.value === value) ? items.find((x) => x.value === value).text : null;
        },
        removeActiveItems() {
            const items = this.$el.querySelectorAll('.updated');
            if (!items.length) {
                return;
            }
            items.forEach((item) => {
                item.classList.remove('updated');
            });
        },
        setActiveItems() {
            if (!this.updatedProps.length) {
                return;
            }
            this.updatedProps.forEach((props) => {
                const field = this.$el.querySelector(`.${props}`);
                if (field) {
                    field.classList.add('updated');
                }
            });
        },
    },
};
</script>
